
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendario",
      function () {
        return require("private-next-pages/calendario/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendario"])
      });
    }
  